import {
    Box,
    Card,
    CardContent,
    Grid,
    Typography
} from "@material-ui/core";
import ActivitiesByThemeChart from "./charts/activities-by-theme-chart";
import TasksByTypeChart from "./charts/tasks-by-type-chart";
import { dashboardStyles } from "./styles";


export const QuantitativeDashboard = ({ data }) => {

    const classes = dashboardStyles()

    return (
        <>
            <Box mt={3}>
                <Grid container spacing={2}>
                    {data?.metrics?.map((metric) => (
                        <Grid item xs={12} sm={6} md={2} key={metric.label}>
                            <Card className={classes.metricCard}>
                                <CardContent>
                                    <Typography className={classes.metricLabel}>
                                        {metric.label}
                                    </Typography>

                                    <Typography className={classes.metricValue}>
                                        {metric.value}
                                    </Typography>

                                    <Typography className={classes.metricVariation}>
                                        {metric.variation}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box>
            <Box mt={3}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={8}>
                        <Card className={classes.filtersCard}>
                            <CardContent>
                                <Typography className={classes.sectionTitle}>
                                    Atividades por área do direito
                                </Typography>
                                {
                                    data &&
                                    <ActivitiesByThemeChart
                                        data={data?.activitiesByArea}
                                    />
                                }
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Card className={classes.filtersCard}>
                            <CardContent>
                                <Typography className={classes.sectionTitle}>
                                    Distribuição de movimentações
                                </Typography>
                                {
                                    data &&
                                    <TasksByTypeChart
                                        data={data?.tasksByType}
                                    />
                                }
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        </>
    )
}